import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ClearFilters = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            d="M17.5265 6.39209L10.5674 13.3512V18.4546C10.5674 18.9649 10.9153 19.1505 11.3393 18.8675L12.5792 18.0405C13.0042 17.7587 13.351 17.1092 13.351 16.5988V12.8873L18.2056 8.03274C19.1074 7.1298 18.8023 6.39209 17.5265 6.39209H17.5265Z"
            fill={color}
        />
        <path
            d="M15.584 5.55064C15.5394 5.45031 15.4819 5.35463 15.3996 5.27228C15.0366 4.90924 14.4503 4.90924 14.0878 5.27228L12.9674 6.39212H6.39215C5.1163 6.39212 4.81014 7.1298 5.71306 8.03277L8.51988 10.8396L5.27228 14.0872C4.90924 14.4502 4.90924 15.0365 5.27228 15.399C5.45322 15.5799 5.6904 15.671 5.92818 15.671C6.16596 15.671 6.40314 15.5799 6.58408 15.399L15.399 6.58407C15.6791 6.30396 15.7371 5.89221 15.584 5.55064H15.584Z"
            fill={color}
        />
    </StarryUIIcon>
);
